<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Формат адреса</div>
            <div :class="fieldValueClass">
                <ai-select-box-clearable
                    v-model:value="value"
                    :data-source="dataSource"
                    :disabled="disabled"
                    :display-expr="meta.extParams.displayExpr"
                    :fieldNameId="meta.fieldNameId"
                    :fieldNameText="meta.fieldNameText"
                    :showClearButton="false"
                    :value-expr="meta.extParams.valueExpr"
                    @opened="onOpenHandler"
                    @valueChanged="valueChanged"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, inject, onBeforeMount, ref } from 'vue';
import AiSelectBoxClearable from '@/components/ai-select-box-clearable.vue';
import { api } from '@/service/http';
//import { getDictionary } from '@/service/card-service';
//import AiFormTextBoxDictionary from '@/components/card-component/ai-form-text-box-dictionary.vue';
const props = defineProps({
    ds: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    callbacks: {
        type: Object,
        default: () => ({
            userDataChanged: null,
            getDictionary: null,
        }),
    },
    meta: {
        type: Object,
        default: () => {},
    },
});

const emit = defineEmits(['AddrPDChanged']);

const serverData = inject('serverData');
const userData = inject('userData');
const dataSource = ref(props.ds);

const onOpenHandler = async () => {
    await getDictionaryHandler();
};

onBeforeMount(async () => {
    if (props.meta.extParams) {
        const initialDS = [
            {
                [`${props.meta.extParams.valueExpr}`]: userData?.value[props.meta.fieldNameId],
                [`${props.meta.extParams.displayExpr}`]: userData?.value[props.meta.fieldNameText],
            },
        ];
        if (dataSource.value.length === 0 && serverData?.value.length !== 0) {
            dataSource.value = [...initialDS];
        }
    }
});

const getDictionaryHandler = async () => {
    dataSource.value = [
        {
            kod: 1,
            name: 'Муниципальный',
        },
        {
            kod: 2,
            name: 'Административный',
        },
    ];
};

const valueChanged = e => {
    userDataChange(e.value, e.text);

    getAdresPD(
        rows => {
            if (rows) {
                userData.value['adres_pd'] = rows[0].adr_pd;
                () => emit('AddrPDChanged');
            }
        },
        err => {
            alert(err);
        }
    );
};

async function getAdresPD(successCallback, failureCallback) {
    const { result, rows } = await api('counteragent./customer/addr_pd/get', {
        kodp: 0,
        mode: userData.value[props.meta.fieldNameId],
    });

    if (result) {
        successCallback(rows);
    } else {
        const err = 'Не удалось получить адрес';
        failureCallback(err);
    }
}

const userDataChange = (value, text) => {
    userData.value[props.meta.fieldNameId] = value;
    if (text) {
        userData.value[props.meta.fieldNameText] = text;
    }
    props.callbacks.userDataChanged();
};

const isModified = computed(() => {
    return userData?.value[props.meta.fieldNameId] !== serverData?.value[props.meta.fieldNameId];
});

const value = computed(() => {
    if (userData.value[props.meta.fieldNameId] === undefined) {
        return null;
    }
    return userData.value[props.meta.fieldNameId];
});

const fieldValueClass = computed(() => {
    return {
        'dx-field-value': true,
        'ai-field-modified': isModified.value,
    };
});
</script>
